import { O as h } from "./OrError-B5ihH6-3.mjs";
import { O as $ } from "./OrHint-NvbZyURY.mjs";
import { O as C } from "./OrLabel-BadqqO3K.mjs";
import { defineComponent as N, ref as E, computed as u, resolveComponent as a, openBlock as l, createElementBlock as V, normalizeClass as f, createBlock as c, withCtx as r, renderSlot as t, createTextVNode as s, toDisplayString as i, createCommentVNode as b, createElementVNode as B, withDirectives as y, vShow as O, createVNode as k } from "vue";
import { _ as H } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var o = /* @__PURE__ */ ((e) => (e.NONE = "none", e.SM = "sm", e.MD = "md", e))(o || {}), n = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(n || {});
const M = [
  // Layout
  "layout-column",
  // Spacing
  "gap-sm"
], q = [], w = {
  [n.Vertical]: [
    // Layout
    "layout-column"
  ],
  [n.Horizontal]: [
    // Layout
    "layout-row"
  ]
}, z = {
  [o.NONE]: [],
  [o.SM]: [
    // Spacing
    "gap-sm"
  ],
  [o.MD]: [
    // Spacing
    "gap-md"
  ]
}, D = N({
  name: "OrFormGroup",
  components: {
    OrError: h,
    OrHint: $,
    OrLabel: C
  },
  props: {
    direction: {
      type: String,
      default: () => n.Vertical
    },
    label: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    error: {
      type: [String, Boolean],
      default: void 0
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    spacing: {
      type: String,
      default: o.SM
    }
  },
  setup(e) {
    const d = E(), p = u(() => [
      "or-form-group-v3",
      ...M
    ]), m = u(() => [
      ...q,
      ...w[e.direction],
      ...z[e.spacing]
    ]);
    return {
      root: d,
      rootStyles: p,
      contentStyles: m
    };
  }
});
function F(e, d, p, m, G, L) {
  const v = a("OrLabel"), g = a("OrHint"), S = a("OrError");
  return l(), V("div", {
    ref: "root",
    class: f(e.rootStyles)
  }, [
    e.$slots.label || e.$slots.addon || e.label ? (l(), c(v, {
      key: 0,
      variant: "group",
      invalid: !!e.error,
      required: e.required,
      disabled: e.disabled
    }, {
      addon: r(() => [
        t(e.$slots, "addon")
      ]),
      default: r(() => [
        t(e.$slots, "label", {}, () => [
          s(i(e.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["invalid", "required", "disabled"])) : b("", !0),
    B("div", {
      class: f(e.contentStyles)
    }, [
      t(e.$slots, "default")
    ], 2),
    e.$slots.hint || e.hint ? y((l(), c(g, {
      key: 1,
      disabled: e.disabled
    }, {
      default: r(() => [
        t(e.$slots, "hint", {}, () => [
          s(i(e.hint), 1)
        ])
      ]),
      _: 3
    }, 8, ["disabled"])), [
      [O, !e.error]
    ]) : b("", !0),
    y(k(S, { disabled: e.disabled }, {
      default: r(() => [
        s(i(e.error), 1)
      ]),
      _: 1
    }, 8, ["disabled"]), [
      [O, typeof e.error == "string" && e.error.length > 0]
    ])
  ], 2);
}
const K = /* @__PURE__ */ H(D, [["render", F]]);
export {
  n as F,
  K as O,
  o as a
};
//# sourceMappingURL=OrFormGroup-C5sateI6.mjs.map
